import { Guid } from "@/Common/Models/Guid";
import { FlowsheetTemplateClient } from "../Api/FlowsheetTemplatesClient";
import { FlowsheetTemplate } from "../Models/FlowsheetTemplate";
import { IUseQueryResponse, useQuery } from "./useQuery";

/**
 * Custom hook to fetch flowsheet templates.
 * @returns An object containing the query response with flowsheet templates.
 */
function useFlowsheetTemplates({ patientId }: { patientId?: Guid } = {}): IUseQueryResponse<FlowsheetTemplate[]> {
    return useQuery({
        query: async () => {
            const response = await FlowsheetTemplateClient.getFlowsheetTemplates({ patientId });

            response.throwIfError();

            return response.data.Data.map(flowsheetTemplate => new FlowsheetTemplate(flowsheetTemplate));
        }
    });
}

export {
    useFlowsheetTemplates
};
